<template>
  <div class="d-flex">
    <div>
      <div class="social-button mr-2" :class="classEndereco">
        <label :class="{ active: activeEndereco }">&nbsp;</label>
      </div>
    </div>
    <div class="text-endereco">
      <div v-if="sem_endereco">Sem endereço físico</div>
      <div v-else-if="endereco.internacional && endereco.pais">
        <span class="d-block">{{ endereco.pais.nome }}</span>
        {{ endereco.internacional_descricao }}
      </div>
      <div v-else>
        {{ endereco.logradouro ? endereco.logradouro + ", " : "" }}
        {{ endereco.numero ? endereco.numero : "" }}
        <span class="d-block">{{ endereco.bairro }}</span>
        <span v-if="endereco.cidade && 'nome' in endereco.cidade">
          {{ endereco.cidade.nome }} /
          {{ endereco.cidade.estado_sigla }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    endereco: {
      type: Object,
      required: true,
    },
    sem_endereco: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tipoEndereco() {
      if (this.sem_endereco) {
        return "sem-endereco";
      }
      if (this.endereco.internacional) {
        return "onu";
      }
      return "brasil";
    },
    classEndereco() {
      return this.tipoEndereco + "-icon";
    },
    activeEndereco() {
      const isActiveAdress =
        ["brasil"].includes(this.tipoEndereco) && !this.endereco.cidade;
      return isActiveAdress;
    },
  },
};
</script>

<style scoped>
.text-endereco {
  font-size: 0.8em;
  line-height: 0.9rem;
}
</style>
